// https://stripe.com/docs/currencies#presentment-currencies
export const ZERO_DECIMAL_CURRENCIES = [
    'bif',
    'clp',
    'dlf',
    'gnf',
    'huf',
    'jpy',
    'kmf',
    'krw',
    'mga',
    'pyg',
    'rwf',
    'ugx',
    'vnd',
    'vuv',
    'xaf',
    'xof',
    'xpf'
];
